import type { DrawerConfig } from '@/features/drawer/types/DrawerConfig';
import type { Theme } from '@mui/material';
import { DRAWER_INDEX } from '@/features/drawer/constants/drawerIndex';
import { DrawerAnchor } from '@/features/drawer/enums/DrawerAnchor';
import { DrawerSize } from '@/features/drawer/enums/DrawerSize';
import { Drawers } from '@/features/drawer/enums/Drawers';
import { defaultTheme } from '@/styles/theme/defaultTheme/defaultTheme';

export const PartyPaymentInformationDrawerConfig: DrawerConfig = {
  theme: defaultTheme as Theme,
  anchor: DrawerAnchor.Right,
  size: DrawerSize.Normal,
  behavior: {
    isHeaderOffsetEnabled: true,
  },
  offsets: {
    right: DrawerSize.ExtraSmall,
  },
  styles: {
    common: {
      zIndex: DRAWER_INDEX,
      background: defaultTheme.palette?.background?.secondary,
    },
  },
  router: {
    allowedRoutes: ['/party-details/'],
    drawerParam: Drawers.PartyPaymentInformation,
    drawerExtraParamsPrefix: Drawers.PartyPaymentInformation,
    drawerExtraParams: [],
  },
};
